module.exports = {
  chargePartTypeKG: 'Phân chia theo trọng lượng (KG)',
  chargePartTypeCBM: 'Tính phí theo thể tích (CBM)',
  chargePartTypeTipsL1: 'mẹo: Loại khoảng cách tính phí là gì?',
  chargePartTypeTipsL2: 'Phân chia theo trọng lượng (KG) có nghĩa là trọng lượng hàng hóa khác nhau thì giá cước vận chuyển khác nhau.',
  chargePartTypeTipsL3: 'Phân chia theo thể tích (CBM) có nghĩa là thể tích hàng hóa khác nhau thì giá cước vận chuyển khác nhau.'
}
